import moment from 'moment';
import START_TIME_MAPPING from './constants';

export const getStartTimeForCode = (code, timestamp = undefined) =>
  moment(timestamp).hours(START_TIME_MAPPING.get(code)).minutes(0).seconds(0).milliseconds(0).valueOf();

export const getStartTimeMappingCodes = () => Array.from(START_TIME_MAPPING.keys());
